import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { pagosApi } from '../../api/pagos'
import { fmtFecha } from '../../utils/fecha'
import { colors, font } from '../../design/tokens'
import { Seccion, Dato, Cargando, ErrorMsg, Titulo, fmtMoney, PagoDot } from './comunes'

// Detalle de un pago, solo lectura (las acciones viven en el escritorio).
export default function MovilPagoDetalle() {
  const { id } = useParams()
  const [pago, setPago] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    pagosApi.obtener(id)
      .then(({ data }) => setPago(data.data ?? data))
      .catch((e) => setError(e.response?.data?.message || 'No se pudo cargar el pago'))
  }, [id])

  if (error) return <ErrorMsg>{error}</ErrorMsg>
  if (!pago) return <Cargando />

  return (
    <div>
      <Titulo>Pago #{pago.id}</Titulo>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '2px 0 10px' }}>
        <span style={{ fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', fontSize: 22, fontWeight: 700, color: colors.text }}>
          {fmtMoney(pago.importe)}
        </span>
        <PagoDot estado={pago.estado} />
        <span style={{ fontSize: 13, color: colors.textSec, fontFamily: font.sans, textTransform: 'capitalize' }}>{pago.estado}</span>
      </div>

      <Seccion titulo="Datos">
        <Dato label="Cliente">{pago.cliente?.nombre || '—'}</Dato>
        <Dato label="Fecha" mono>{pago.fecha ? fmtFecha(pago.fecha) : '—'}</Dato>
        <Dato label="Medio">{pago.medio_pago?.nombre || pago.medioPago?.nombre || pago.medio || '—'}</Dato>
        {pago.numero_presea && <Dato label="Recibo Presea" mono>{pago.numero_presea}</Dato>}
        {pago.origen && <Dato label="Origen">{pago.origen}</Dato>}
        {pago.id_transaccion && <Dato label="Transacción" mono>{pago.id_transaccion}</Dato>}
        {/* Detalle del cobro con tarjeta (Martin, 26 sep 2026: "necesito ver
            detalles del recibo de pago como las cuotas"). */}
        {pago.marca && <Dato label="Tarjeta">{pago.marca}</Dato>}
        {pago.cuotas > 0 && <Dato label="Cuotas" mono>{pago.cuotas === 1 ? '1 pago' : `${pago.cuotas} cuotas`}</Dato>}
        {pago.cod_autorizacion && <Dato label="Autorización" mono>{pago.cod_autorizacion}</Dato>}
        {pago.nro_cupon_cheque && <Dato label="Cupón / cheque" mono>{pago.nro_cupon_cheque}</Dato>}
        {pago.lote && <Dato label="Lote" mono>{pago.lote}</Dato>}
        {pago.observaciones && <Dato label="Observaciones">{pago.observaciones}</Dato>}
      </Seccion>

      {(pago.valores?.length > 0) && (
        <Seccion titulo="Valores">
          {pago.valores.map((v, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: 13.5, fontFamily: font.sans, color: colors.text, borderBottom: `1px solid ${colors.borderSoft}` }}>
              <span>{v.tipo || v.descripcion || 'Valor'}</span>
              <span style={{ fontFamily: font.mono }}>{fmtMoney(v.importe)}</span>
            </div>
          ))}
        </Seccion>
      )}

      {(pago.imputaciones?.length > 0 || pago.notas_venta?.length > 0) && (
        <Seccion titulo="Imputado a">
          {(pago.imputaciones || pago.notas_venta || []).map((n, i) => (
            <div key={i} style={{ padding: '6px 0', fontSize: 13.5, fontFamily: font.mono, color: colors.text, borderBottom: `1px solid ${colors.borderSoft}` }}>
              {n.numero_lgr || n.nota_venta?.numero_lgr || n.numero || `NV ${n.nota_venta_id || n.id}`}
            </div>
          ))}
        </Seccion>
      )}

      {pago.observaciones && (
        <Seccion titulo="Observaciones">
          <p style={{ margin: 0, fontSize: 13.5, fontFamily: font.sans, color: colors.textSec, lineHeight: 1.5 }}>{pago.observaciones}</p>
        </Seccion>
      )}

      <p style={{ marginTop: 14, fontSize: 12, color: colors.textMeta, fontFamily: font.sans }}>
        Confirmar, enviar a Presea o anular se hace desde LGR completo.
      </p>
    </div>
  )
}
